import { modelToOps, type PresetModel } from "@defibrillator/preset-core";
import type { PresetSaveResponse } from "../../shared/types.js";

export class PresetSaveError extends Error {
  readonly status: number;
  readonly body: unknown;

  constructor(message: string, status: number, body: unknown) {
    super(message);
    this.name = "PresetSaveError";
    this.status = status;
    this.body = body;
  }
}

export async function savePresetDraft(params: {
  presetId: string;
  baseVersionId: string;
  model: PresetModel;
}): Promise<PresetSaveResponse> {
  const res = await fetch(`/api/presets/${params.presetId}`, {
    method: "PUT",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      baseVersionId: params.baseVersionId,
      ops: modelToOps(params.model),
    }),
  });

  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message =
      typeof body === "object" && body && "error" in body
        ? String((body as { error: unknown }).error)
        : `save_failed_${res.status}`;
    throw new PresetSaveError(message, res.status, body);
  }

  return body as PresetSaveResponse;
}
